import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=2f85c240&scoped=true"
import script from "./ContentDetail.vue?vue&type=script&lang=js"
export * from "./ContentDetail.vue?vue&type=script&lang=js"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=2f85c240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85c240",
  null
  
)

export default component.exports